// Option Daily (1) has been removed. We will maintain the gap to prevent mismatches with other codes that might use this enum.
export enum InterruptionModeEnum {
    interruptionOff = 0,
    startStop = 2,
    continuous = 3,
    cathodicProtectionOff = 4
}
